import React, { Component } from "react";
export default class DotCountingSection extends Component {
  render() {
    var {
      dot_countring_score,
      dot_status_1,
      dot_status_2,
      dot_status_3,
      dot_status_4,
    } = this.props.data;
    return (
      <div className="row border border-dark dot_counting_section">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas-form/dot-images/1.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas-form/dot-images/2.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas-form/dot-images/3.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas-form/dot-images/4.png"}
                  alt="scorpion"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div>
            <br />
            <span className="fs-18">Score (0-4) </span>
            <input
              type="number"
              disabled
              name="dot_countring_score"
              value={dot_countring_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
